import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectSuperModelManufacturerFilter,
  selectSuperModelManufacturerOptions,
} from "../../redux/selector";
import { superModelActions } from "../../redux/slice";
import {
  SuperModelManufacturerFilter,
} from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(selectSuperModelManufacturerFilter);
  const manufacturerOptions = useSelector(selectSuperModelManufacturerOptions);

  const allLabel = t("SUPER_MODEL.FILTERS.ALL");

  const manufacturerSelectOptions = useMemo(
    () => ["ALL", ...manufacturerOptions.map(({ id }) => String(id))],
    [manufacturerOptions]
  );

  const getManufacturerLabel = (value: SuperModelManufacturerFilter) => {
    if (value === "ALL") {
      return allLabel;
    }

    return (
      manufacturerOptions.find(({ id }) => String(id) === value)?.name ?? value
    );
  };

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("SUPER_MODEL.ACTIONS.ADD")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("SUPER_MODEL.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter}
          options={manufacturerSelectOptions}
          getOptionLabel={getManufacturerLabel}
          menuMaxHeight={240}
          onChange={(value) => {
            dispatch(superModelActions.setManufacturerFilter(value));
            dispatch(superModelActions.getSuperModelsList());
          }}
        />
      </div>
    </div>
  );
};

export default ActionBar;
